import React, { useState } from "react";

export default function Melhorias() {
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [sugestao, setSugestao] = useState("");
  const [enviado, setEnviado] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // TODO: Criar função para enviar sugestão ao banco de dados
    // Função: salvarSugestao({ nome, email, sugestao })

    setEnviado(true);
    setNome("");
    setEmail("");
    setSugestao("");
  };

  return (
    <div className="max-w-xl mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4 text-center">Sugestões de Melhorias</h1>
      <div className="border border-gray-300 rounded-lg shadow-sm">
        <div className="p-4">
          {enviado ? (
            <div className="text-green-600 font-semibold text-center">
              Obrigado pela sua sugestão!
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label htmlFor="nome" className="block text-sm font-medium text-gray-700">Nome (opcional)</label>
                <input
                  id="nome"
                  value={nome}
                  onChange={(e) => setNome(e.target.value)}
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm p-2"
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email (opcional)</label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm p-2"
                />
              </div>
              <div>
                <label htmlFor="sugestao" className="block text-sm font-medium text-gray-700">Sugestão</label>
                <textarea
                  id="sugestao"
                  required
                  rows={5}
                  value={sugestao}
                  onChange={(e) => setSugestao(e.target.value)}
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm p-2"
                />
              </div>
              <button
                type="submit"
                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-md"
              >
                Enviar Sugestão
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
